export interface VolumeChannelType {
  value: number;
  temporaryValue: number | null;
  previousValue: number;
}

export type UiChannelType = string | null;

export interface ChannelsType extends Record<string, VolumeChannelType> {}

export interface IVolumeSettings {
  master: VolumeChannelType;
  channels: ChannelsType;
  uiChannel: UiChannelType;
  noVolumeControl?: boolean;
  restored?: boolean;
}

export enum StreamQuality {
  High = 0,
  Medium = 1,
  Low = 2,
  Auto = 'auto',
}

export interface IStreamState {
  isEnabled: boolean;
  isEnabledBySystem: boolean;
  isVideoPlaying: boolean;
  quality: StreamQuality;
  qualityLimit: number;
  streamLatency: number;
}

export interface ILanguageState {
  current: string;
  isRTL: boolean;
}

export interface ISettingsInitialState {
  isInFullscreen: boolean;
  isGameVisible: boolean;
  stream: IStreamState;
  volume: IVolumeSettings;
  language: ILanguageState | Record<string, never>;
  showOtherMessages: boolean;
  isAnimationToggle: boolean;
  isSecondBetBoardToggle: boolean;
  isStudioSoundDisabled?: boolean;
}

export type ChannelVolumeCallbackType = (channelName: string) => VolumeChannelType | null;

export interface ChannelVolumeValueCallbackType {
  (channelName: string): number;
}
